import {
    getCoreRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    getSortedRowModel,
    useReactTable,
} from "@tanstack/react-table";
import { useEffect, useState } from 'react';
import { Link } from 'react-router';
import '../../App.css';
import api from '../../lib/api';
import { DataTable } from './datatable';
import DatatableSortButton from './datatableSortButton';

export const columns = () => [
    {
        accessorKey: "placing",
        header: ({ column }) => <DatatableSortButton column={column}>Placering</DatatableSortButton>,
        cell: info => `${info.getValue() || 'opl'} av ${info.row.original.totalParticipants}`,
    },
    {
        accessorKey: "driver.first_name",
        header: ({ column }) => <DatatableSortButton column={column}>Förare</DatatableSortButton>,
        cell: info => (
            <span>{`${info.row.original.driver.first_name} ${info.row.original.driver.last_name}`}</span>
        ),
    },
    {
        accessorKey: "class.name",
        header: ({ column }) => <DatatableSortButton column={column}>Klass</DatatableSortButton>,
        cell: info => (<Link className='text-blue-600 font-medium hover:underline' to={`/competition/${info.row.original.competition.id}/class/${info.row.original.class.id}`}>{info.getValue()}</Link>) || "Ingen klassnamn",
    },
    {
        accessorKey: "class.date",
        header: ({ column }) => <DatatableSortButton column={column}>Datum</DatatableSortButton>,
        cell: info => new Date(info.getValue()).toLocaleDateString("sv-SE"),
    },
    {
        accessorKey: "competition.name",
        header: ({ column }) => <DatatableSortButton column={column}>Tävling</DatatableSortButton>,
        cell: info => (<Link className='text-blue-600 font-medium hover:underline' to={`/competition/${info.row.original.competition.id}`}>{info.getValue()}</Link>) || "Ingen tävling",
    },
];

export function HLBunnyCompetitionResults({ bunnyId }) {
    const [sorting, setSorting] = useState([{ id: 'class_date', desc: true }]);
    const [columnFilters, setColumnFilters] = useState([]);
    const [results, setResults] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const fetchResults = async () => {
        try {
            const response = await api.get(`https://skhrf-api.cmdigital.se/v1/bunnies/results/classes?bunnyId=${bunnyId}`);
            setResults(response.data);
        } catch (error) {
            console.error('Error fetching drivers:', error);
            setResults([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchResults();
    }, []);

    const table = useReactTable({
        data: results,
        columns: columns(),
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        onSortingChange: setSorting,
        getSortedRowModel: getSortedRowModel(),
        onColumnFiltersChange: setColumnFilters,
        getFilteredRowModel: getFilteredRowModel(),
        state: {
            sorting,
            columnFilters,
        },
    });

    return (
        <DataTable
            table={table}
            isLoading={isLoading}
            columns={columns()}
        />
    );
}
